var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"membership-select"},[_c('v-select',{attrs:{"items":_vm.items,"item-value":"text"},on:{"input":_vm.selected},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }